export const ListQueryKey = 'nolimitExchanges';
export const DetailQueryKey = 'nolimitExchange';

export const Urls = {
  selectUrl: '/nolimitExchange/list',
  updateUrl: '/nolimitExchange/update',
};
